import React, { useEffect } from 'react'
import Photo from '../components/Photo'
import Header from '../components/Header'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react'
import axios from 'axios'
import SuccessScreen from '../components/SuccessScreen'

const Gallery = () => {
  const { sessionId } = useParams();
  const [currentStep, setCurrentStep] = useState(false);
  // const navigate = useNavigate();
const handleNext = () => {
        // console.log(formData)
        setCurrentStep(true);

    };
  const handleSubmit = async () => {
    setSend(true);
    try {
      const formData = new FormData();
      const img_burns = [];
      // Object.entries(photos).forEach(([key, value]) => {
      //   if (value) {
      //     formData.append('images_burn', value, `image_${key}.jpg`);
      //   }
      // });
      for (const [key,value] of Object.entries(photos)) {
        if (value) {
          const file = new File([value], `image_${key}.jpg`, { type: 'image/jpeg' });
          // img_burns.push(file);
          // console.log(img_burns)
               formData.append('img_burns', file); // בלי סוגריים מרובעים בשם השדה
        }
      }
      // formData.append('img_burns', img_burns)

      const response = await axios.post(`/dashboard/images_burn/${sessionId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.status == 200)
        handleNext()
      setSend(false);
        
        // navigate(`/Questionnaire/${sessionId}`)
      console.log('תמונות נשמרו בהצלחה:', response.data);
    } catch (error) {
      console.error('שגיאה בהעלאת התמונות:', error);
      alert('שגיאה בשליחת התמונות לשרת');
      setSend(false);
    }
  };
   const [send, setSend] = useState(false);


  const [photos, setPhotos] = useState({
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
  });

  useEffect(() => {
    console.log(photos)
  }, [photos])
  console.log(photos)
  const add = (id, data) => {
    setPhotos((prev) => ({ ...prev, [id]: data }));
  };

  const remove = (id) => {
    setPhotos((prev) => ({ ...prev, [id]: null }));
  };
  return (
    <div className='w-full h-screen  '>
      <Header></Header>
      {!send&&!currentStep&&<div className='w-full h-[90%] p-7 flex flex-col justify-between items-center'>
        <div className='w-full my-auto'>
          <div className=' w-full  grid grid-cols-3 gap-2  '>
            <Photo id="1" add={add} remove={remove}></Photo>
            <Photo id="2" add={add} remove={remove}></Photo>
            <Photo id="3" add={add} remove={remove}></Photo>
            <Photo id="4" add={add} remove={remove}></Photo>
            <Photo id="5" add={add} remove={remove}></Photo>
            <Photo id="6" add={add} remove={remove}></Photo>
          </div>
          <p className='text-sm mt-3 text-right' style={{ direction: "rtl" }}>בלחיצה על כפתור “ שמירה וסיום” אני מאשר.ת כי לא ניתן לזהות פנים בתמונות אותם צילמתי.</p>
        </div>
        <button onClick={handleSubmit} disabled={!photos} className='bg-PraimeryBlue text-white px-5 py-4 m-3 rounded-lg text-lg w-full font-bold '> שמירה וסיום</button>

      </div>}
        {send && <div className='w-full h-[80%] flex justify-center items-center'><p>...טוען<div class="border-gray-300 h-12 w-12 animate-spin rounded-full border-8 border-t-PraimeryBlue" /></p></div>}

        {currentStep && <SuccessScreen></SuccessScreen>}

    </div>
    
  )
}

export default Gallery